import { Auth } from 'aws-amplify';

const verifyEmail = async (email, code) => {
  if (!email || !code) throw new Error('Email or code is empty');

  return Auth.confirmSignUp(email.trim(), code);
};

export default verifyEmail;
